import { Input as InputProps } from "./index.types";
import "./index.css";
import clsx from "clsx";

export function Input({
  inputClassName = "",
  classNameGroup = "",
  error = {
    is: false,
    message: "",
  },
  inputRef,
  styleGroup,
  placeholder = "Insert value",
  label,
  labelClassName,
  icon,
  isRequired,
  backgroundColor,
  ...rest
}: InputProps) {
  return (
    <div
      className={clsx("input-group", classNameGroup)}
      style={{ backgroundColor: backgroundColor, ...styleGroup }}
    >
      <div className="input__header">
        {label && <label className={labelClassName}>{label}</label>}
        {error && error.is && (
          <span className="input__header--error">
            {error.message as string}
          </span>
        )}
      </div>
      <div className="input-subgroup">
        {icon?.element && icon.position === "left" && (
          <div
            className={clsx("input__icon", "input__icon--left", icon.className)}
          >
            {icon.element}
          </div>
        )}
        <input
          ref={inputRef}
          required={isRequired}
          className={clsx(
            "input",
            error.is ? "input--error" : "",
            icon?.position === "left" && "input--icon",
            inputClassName
          )}
          placeholder={placeholder}
          {...rest}
        />
        {icon?.element && icon.position !== "left" && (
          <div
            className={clsx(
              "input__icon",
              "input__icon--right",
              // `input__icon--${icon.position || "right"}`,
              icon.className
            )}
          >
            {icon.element}
          </div>
        )}
      </div>
    </div>
  );
}

export default Input;
